import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import Login from './pages/Login';
import Home from './pages/Home';
import Municipio from './pages/Municipio';
import Propriedade from './pages/Propriedade';
import ConsultaCar from './pages/ConsultaCar';
import ProcessaCar from './pages/ProcessaCar';

const router = createBrowserRouter(
  [
    { path: '/', element: <Login /> },
    { path: '/home', element: <Home /> },
    { path: '/municipio', element: <Municipio /> },
    { path: '/propriedade', element: <Propriedade /> },
    { path: '/consulta-car', element: <ConsultaCar /> },
    { path: '/expo', element: <ProcessaCar /> },
  ],
  {
    // future: {
    //   v7_startTransition: true,
    // }
  }
);

function Rotas() {
  return <RouterProvider router={router} />;
}

export default Rotas;
